import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import ProjectPhoto from './ProjectPhoto';

import styles from './ProjectCoverPhotoContainer.scss';

import type { ProjectCoverPhotoContainer_searchResult$key } from './__generated__/ProjectCoverPhotoContainer_searchResult.graphql';

type Props = {
    searchResult: ProjectCoverPhotoContainer_searchResult$key | null;
    openModal: (currentUrl: string) => void;
};

const ProjectCoverPhotoContainer: FC<Props> = (props: Props) => {
    const { openModal, searchResult: searchResultRef } = props;

    const searchResult = useFragment(
        graphql`
            fragment ProjectCoverPhotoContainer_searchResult on TradeInteriorProjectQueryOutput {
                project {
                    tradeCoverPhoto {
                        ...ProjectPhoto_tradePhoto
                        caption
                    }
                }
            }
        `,
        searchResultRef
    );

    const tradePhoto = searchResult?.project?.tradeCoverPhoto || null;

    return (
        <>
            <ProjectPhoto
                isCoverPhoto
                className={styles.photo}
                openModal={openModal}
                tradePhoto={tradePhoto}
            />
            <div className={styles.caption}>
                <FormattedMessage
                    id="abt.interiorsProject.coverPhoto.caption"
                    defaultMessage="Photography: {caption}"
                    values={{
                        caption: tradePhoto?.caption || '',
                    }}
                />
            </div>
        </>
    );
};

export default ProjectCoverPhotoContainer;
